export const USER_CACHE_KEY = "USERS";
export const ALL_USERS_CACHE_KEY = [USER_CACHE_KEY, "ALL"];
export const USER_PREFERENCES_CACHE_KEY = [USER_CACHE_KEY, "preferences"];
